import { render, staticRenderFns } from "./JSelectDepartModal.vue?vue&type=template&id=1ed48c56&scoped=true"
import script from "./JSelectDepartModal.vue?vue&type=script&lang=js"
export * from "./JSelectDepartModal.vue?vue&type=script&lang=js"
import style0 from "./JSelectDepartModal.vue?vue&type=style&index=0&id=1ed48c56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed48c56",
  null
  
)

export default component.exports